// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"d0f22c85","256":"82e000f9","391":"0d276227","453":"e848b8a2","844":"31f1469f","868":"c91b4414","929":"17154815"}[chunkId] + ".chunk.js";
};